export const selectOpportunityState = (state) => state.opportunity;
